import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import OrganizationChildResources from "OrganizationResources/routes/OrganizationChildResouces";
export default store => ({
  path: "workbookresources",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "organization-educatorCenter" */ "OrganizationResources/EducatorCenterParent"
        ),
        import(
          /* webpackChunkName: "organization-educatorCenter" */ "OrganizationResources/modules/OrganizationResourcesModule"
        ),
        import(
          /* webpackChunkName: "organization-educatorCenter" */ "Teacher/modules/TeacherModule"
        ),
        import(
          /* webpackChunkName: "organization-educatorCenter" */ "Administrator/modules/AdministratorModule"
        ),
      ]).then(
        ([
          importedModule0,
          importedModule1,
          importedModule2,
          importedModule3,
        ]) => {
          const component = importedModule0.default;
          const reducer = importedModule1.default;
          const teacherReducer = importedModule2.default;
          const administratorReducer = importedModule3.default;
          injectReducer(store, {
            key: "administrator",
            reducer: administratorReducer,
          });
          injectReducer(store, {
            key: "teacher",
            reducer: teacherReducer,
          });
          injectReducer(store, {
            key: "organizationResource",
            reducer,
          });
          return component;
        }
      )
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [OrganizationChildResources(store)],
});
